module.exports = __webpack_public_path__ + "static/media/home.1c03d925.svg";